import { Pipe, PipeTransform } from '@angular/core';
import { Observable, map } from 'rxjs';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { MenuItem } from 'src/app/services/models/me-user';

@Pipe({
  name: 'featureFlag'
})
export class FeatureFlagPipe implements PipeTransform {

  constructor(private featureState: FeatureFlagService) {}

  transform(value: MenuItem[], flag: string): Observable<MenuItem[]> {
      return this.featureState.hasFeatureFlag(flag).pipe(
        map((hasFlag) => {
          if (!hasFlag) {
            return value.filter((item) => item.name !== 'INDEX');
          } else {
            return value;
          }
        })
      );
  }
}